<template>
  <span>{{ phoneNumber }}</span>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps<{ number?: string | null }>();

const phoneNumber = computed(() => {
  if (!props.number) return '';

  return `(${props.number.substring(0, 3)}) ${props.number.substring(3)}`;
});
</script>
